/**
 * File: apps/qbench-cp/reactapp/src/shared/hooks/misc/useRecurrenceParameters.js
 *
 * Purpose: Determines whether the test-recurrence feature is enabled based on permission and
 *     field-configuration visibility.
 *
 * Scope: recurrence feature gating for the Test entity's estimated start/complete date fields.
 *
 * Tags: customer-portal, orders
 *
 * Overview: Fetches the Test entity's estimated_start_date and estimated_complete_date field
 *     configs and checks the TEST_RECURRENCE_CREATE portal-view permission. Recurrence is
 *     considered enabled only when the permission is granted and both date fields are
 *     configured to show.
 *
 * Exports: default useRecurrenceParameters hook.
 */

import { useFieldConfig } from 'context/fields';
import { EntityType } from 'shared/constants/entityTypes';
import { PORTALVIEW_PERMISSION } from 'shared/constants/fields';
import usePermissionCheck from './usePermissionCheck';

const fieldsToShow = ['estimated_start_date', 'estimated_complete_date'];

// Settings & Enablement mechanics
export default function useRecurrenceParameters() {
  const { getFields } = useFieldConfig();
  const fields = getFields({
    entityType: EntityType.TEST,
    showAllFields: true,
    fieldsToShow,
  });
  const isSettingEnabled = usePermissionCheck(
    PORTALVIEW_PERMISSION.TEST_RECURRENCE_CREATE,
  );
  const fieldsShown = fields.length === 2;

  return {
    isEnabled: isSettingEnabled && fieldsShown,
  };
}
